import type {DAL} from '@wix/document-manager-core'
import type {
    Pointer,
    Pointers,
    CompRef,
    ManifestFeature,
    ManifestFeatureComponentStageGfpp
} from '@wix/document-services-types'
import {getComponentType} from '../../../utils/dalUtils'
import {MANIFEST_FEATURE_NAME} from '../manifestUtils'
import type {FeaturesAPI} from '../../features/features'
import type {NicknamesAPI} from '../../nicknames'
import type {COMP_TYPES} from '../../../constants/constants'

export class ComponentRepository {
    constructor(
        private readonly features: FeaturesAPI,
        private readonly nicknames: NicknamesAPI,
        private readonly dal: DAL,
        private readonly pointers: Pointers
    ) {}

    getComponentsByTypeForPage(pageId: string, type: (typeof COMP_TYPES)[keyof typeof COMP_TYPES]): Pointer[] {
        return this.pointers.structure.getComponentsByTypeForPage(type, pageId)
    }

    getManifestData(pointer: Pointer): ManifestFeature | undefined {
        return this.features.component.get(pointer, MANIFEST_FEATURE_NAME)
    }

    getComponentType(pointer: Pointer) {
        return getComponentType(this.dal, pointer)
    }

    getComponentPage(compPointer: Pointer) {
        return this.pointers.structure.getPageOfComponent(compPointer)
    }

    getRoleByWidgetRoot(compPointer: Pointer, widgetRootPointer: Pointer) {
        const nicknameMap = this.nicknames.getComponentNickname(compPointer, widgetRootPointer as CompRef)
        return Object.values(nicknameMap)[0]
    }

    getGfppData(pointer: Pointer): ManifestFeatureComponentStageGfpp | undefined {
        return this.getManifestData(pointer)?.gfpp
    }
}
